<template>
  <div class="dashboard-view">
    <title-component :size="1">
      <translate>Dashboard</translate>
      <div class="is-pulled-right">
        <button class="button is-info is-uppercase" @click="applyForService()">
          <translate>Apply for new service</translate>
        </button>
      </div>
    </title-component>
     <message-component
      v-if="customer.shouldShowEmailGlnWarning"
      level="danger">
        <div class="is-flex-direction-row">
          <div class="is-flex-direction-column">
            <translate>
              Please, update your invoice information as you are missing invoice e-mail address or GLN.
            </translate>
          </div>
          <div class="is-flex-direction-column">
            <submit-btn-component class="is-success is-outlined mt-10" @submit="redirectToEdit">
              <translate>Edit information</translate>
            </submit-btn-component>
          </div>
        </div>
    </message-component>
    <message-component
      v-if="customer.shouldShowOldInformationAlert"
      level="warning">
        <div class="is-flex-direction-row">
          <div class="is-flex-direction-column">
            <translate>
              Please, remember to keep your contact information up to date as it ensures that we can get into contact with you for reminders about reporting and renewal cases.
            </translate>
          </div>
          <div class="is-flex-direction-column">
            <submit-btn-component class="is-success is-outlined mt-10" @submit="redirectToEdit">
              <translate>Edit information</translate>
            </submit-btn-component>
          </div>
        </div>
    </message-component>
    <issues-view :customer="customer"></issues-view>
    <table-component-buefy
      v-if="mixin.loaded"
      :content="cases"
      :headings="headings"
      :item_keys="item_keys"
      :display_spec="caseSpecs"
      :total_items="mixin.total_items"
      :pagination_callback="mixin.loadItems"
      :hidden_columns="['modified', 'created']"
      class="veridens-dashboard">
      <translate>Your ongoing cases</translate>
    </table-component-buefy>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import IssuesView from '../issues/IssuesView.vue'
  import { caseSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import { CaseState } from '@/classes/case/Case'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'

  export default {
    name: 'dashbaord-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Case number', 'Certification', 'Qualification', 'Case type', 'Created', 'State', 'Responsible', 'Progress', 'Updated'],
        item_keys: ['caseLink', 'service.shortName', 'qualification.value', 'caseType.display', 'created', 'state', 'responsible.profileTypeDisplay', 'progress', 'modified'],
        caseSpecs: caseSpecs,
        mixin: { actionMethod: this.getCases, actionParams: { 'state': CaseState.ongoingStates() } }
      }
    },
    components: {
      IssuesView,
      TitleComponent,
      TableComponentBuefy,
      MessageComponent,
      SubmitBtnComponent
    },
    computed: {
      ...mapState({
        cases: state => state.caseModule.cases,
        customer: state => state.profileModule.customerProfile
      })
    },
    methods: {
      ...mapActions([
        'getCases',
        'getCustomerProfile',
        'updatePreviousLogin'
      ]),
      applyForService () {
        this.$router.push({ name: 'ApplyForServiceView' })
      },
      redirectToEdit () {
        this.$router.push({ name: 'CustomerEditView' })
      }
    },
    created () {
      this.getCustomerProfile().catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>
<style lang="sass" scoped>
  .veridens-dashboard
    @media screen and (min-width: 765px) and (max-width: 895px)
      font-size: 1.3vw
  .button
    height: auto
    width: auto
    padding: 0.7rem 1rem
</style>
